import { ROUTES } from '#/config/routes';
import {
  createFixedMultiFilterMeta,
  createTextFilterMeta,
} from '#/modules/commonComponents/table/columnFilterMeta';
import { createDocumentNavLinksColumn } from '#/modules/commonComponents/table/tableColumnHelpers';
import { renderEntityStatusBadge } from '#/modules/commonComponents/table/entityStatusIconHelpers';
import TruncatedTextWithTooltip from '#/modules/commonComponents/table/TruncatedTextWithTooltip';
import {
  BOM_STATUS_FILTER_OPTIONS,
} from '#/modules/momMgmt/settings/bom/helper/bomStatus';

export function buildBomColumns({
  filters = {},
  onFilterChange,
  canShowEdit = () => true,
} = {}) {
  return [
    createDocumentNavLinksColumn({
      getDetailPath: (row) => ROUTES.bomDetail(row.id),
      getEditPath: (row) => ROUTES.bomEdit(row.id),
      canShowEdit,
    }),
    {
      header: 'BOM代號',
      accessorKey: 'code',
      size: 120,
      enableColumnFilter: true,
      meta: createTextFilterMeta({
        key: 'code',
        label: 'BOM代號',
        filterValue: filters.code,
        onChange: (value) => onFilterChange('code', value),
        placeholder: '搜尋代號',
      }),
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={row.original?.code || '—'} />
      ),
    },
    {
      header: 'BOM名稱',
      accessorKey: 'name',
      size: 200,
      enableColumnFilter: true,
      meta: {
        cellClassName: 'td_left',
        ...createTextFilterMeta({
          key: 'name',
          label: 'BOM名稱',
          filterValue: filters.name,
          onChange: (value) => onFilterChange('name', value),
          placeholder: '搜尋名稱',
        }),
      },
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={row.original?.name || '—'} />
      ),
    },
    {
      header: '版本',
      accessorKey: 'version',
      size: 96,
      enableColumnFilter: true,
      meta: createTextFilterMeta({
        key: 'version',
        label: '版本',
        filterValue: filters.version,
        onChange: (value) => onFilterChange('version', value),
        placeholder: '搜尋版本',
      }),
    },
    {
      id: 'status',
      header: '狀態',
      accessorKey: 'status',
      size: 88,
      enableColumnFilter: true,
      cell: ({ row }) => renderEntityStatusBadge(row.original.status),
      meta: createFixedMultiFilterMeta({
        key: 'status',
        label: '狀態',
        options: BOM_STATUS_FILTER_OPTIONS,
        filterValue: filters.status,
        onChange: (value) => onFilterChange('status', value),
      }),
    },
    {
      header: '備註',
      accessorKey: 'remark',
      size: 200,
      enableSorting: false,
      enableColumnFilter: true,
      meta: {
        cellClassName: 'td_left',
        ...createTextFilterMeta({
          key: 'remark',
          label: '備註',
          filterValue: filters.remark,
          onChange: (v) => onFilterChange('remark', v),
          placeholder: '搜尋備註',
        }),
      },
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={row.original?.remark || '—'} />
      ),
    },
  ];
}
